<template>
  <div>
    <el-popover
      ref="feedbackPopover"
      :offset="80"
      popper-class="feedback-idioms-popover"
      :visible-arrow="false"
      trigger="manual"
      v-model="idiomsVisible"
      @hide="closeIdiomsPopover"
    >
      <div class="idioms-popover-main">
        <p class="el-icon-error" @click="idiomsVisible = false"></p>
        <div class="idioms-popover-header">
          <div class="idioms-popover-header-right">
            <div class="idioms-popover-search">
              <Search
                ref="listSearch"
                @listSearchEvn="searchHandle"
              />
            </div>
            <!-- <el-button type="primary">导出</el-button> -->
          </div>
        </div>
        <div class="idioms-popover-content">
          <div class="idioms-popover-classify">
            <div class="idioms-popover-classify-main" v-bar>
              <el-tree
                class="idioms-tree"
                ref="idiomsTree"
                :data="classifyTree"
                node-key="_id"
                :expand-on-click-node="false"
                :default-expanded-keys="defaultExpandedKeys"
                :highlight-current="true"
                @node-expand="nodeExpand"
                @node-collapse="nodeCollapse"
                @node-click="classifyTreeClick"
              >
                <div class="idioms-tree-node" slot-scope="{ node, data }">
                  <p class="idioms-tree-node-name omitText" :title="data.name">
                    {{ data.name }}
                  </p>
                  <div>
                    <el-button
                      type="text"
                      size="mini"
                      class="el-icon-plus"
                      @click.stop="addClassify(data)"
                    />

                    <el-button
                      type="text"
                      size="mini"
                      class="el-icon-edit"
                      @click.stop="editClassify(data)"
                    />

                    <el-button
                      type="text"
                      size="mini"
                      class="el-icon-delete"
                      @click.stop="delClassify(data)"
                    />
                  </div>
                </div>
              </el-tree>
            </div>
            <p class="idioms-addClassify" @click="addClassify()">添加</p>
          </div>
          <div class="idioms-main">
            <template v-if="classifyItem">
              <div v-bar class="idioms-popover-list">
                <div>
                  <div
                    class="idioms-popover-item"
                    v-for="(item, index) in idioms"
                    :key="item._id"
                    @click="setIdioms(item.content)"
                  >
                    <el-tooltip effect="dark" placement="top" :enterable="false">
                      <div slot="content">
                        <p v-html="filterDesc(item.content)"></p>
                      </div>
                      <p class="omitText">{{ item.content }}</p>
                    </el-tooltip>
                    <div>
                      <i class="el-icon-edit" @click.stop="editIdioms(item)"></i>
                      <i
                        class="el-icon-delete"
                        @click.stop="delIdioms(item._id, index)"
                      ></i>
                    </div>
                  </div>
                </div>
              </div>
              <p class="feedback-addIdioms" @click="addIdioms">添加</p>
            </template>
          </div>
        </div>
      </div>
      <div slot="reference" class="idioms-popover-value">
        <p class="global-button-style" @click="idiomsVisible = !idiomsVisible">
          常用语
        </p>
      </div>
    </el-popover>

    <el-dialog
      :title="dialogTitle"
      :visible.sync="showClassify"
      width="35%"
      center
      @close="clearDialog"
    >
      <div>
        <p>分类</p>
        <el-input
          ref="classifyInput"
          placeholder="请输入内容"
          v-model="classifyForm.name"
          @keyup.enter.native="addClassifyEvn"
          clearable
        ></el-input>
      </div>
      <span slot="footer">
        <el-button @click="clearDialog">取消</el-button>
        <el-button type="primary" @click="addClassifyEvn">确定</el-button>
      </span>
    </el-dialog>

    <el-dialog
      :title="dialogTitle"
      :visible.sync="showIdioms"
      width="35%"
      center
      @close="clearDialog"
    >
      <div>
        <p>常用语</p>
        <el-input
          ref="idiomsInput"
          type="textarea"
          resize="none"
          v-model="idiomsForm.content"
          @keydown.enter.exact.prevent.stop.native="addEvn"
          @keyup.shift.enter.prevent.exact.stop.native
          placeholder="请输入内容"
        ></el-input>
      </div>
      <span slot="footer">
        <el-button @click="clearDialog">取消</el-button>
        <el-button type="primary" @click="addEvn">确定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import Search from '@/components/listSearch'
export default {
  components: {
    Search
  },
  data() {
    return {
      idiomsVisible: false,
      showIdioms: false,
      showClassify: false,
      idioms: [],
      dialogTitle: '',
      idiomsParams: {
        limit: 1000,
        idiomCategory: null
      },
      idiomsItem: null,
      idiomsForm: {
        content: '',
        idiomCategory: ''
      },
      defaultExpandedKeys: [],
      classifyTree: [],
      classifyItem: null,
      classifyEditItem: null,
      classifyForm: {
        parent: null,
        name: ''
      },
      searchVal: ''
    }
  },
  methods: {
    // ============= 常用语分类 ===========================
    async getIdiomsClassify() {
      let params = {}
      this.searchVal ? params.idiomName = this.searchVal : delete params.idiomName
      let res = await this.$http.getIdiomsClassify(params)
      this.classifyTree = res.data
      try {
        if (!this.classifyTree.length) {
          this.classifyItem = null
          this.idioms = []
          return
        }
        if (!this.classifyItem) {
          this.classifyItem = this.classifyTree[0]
          this.idiomsParams.idiomCategory = this.classifyTree[0]._id
        }
        this.$nextTick(() => {
          this.$refs.idiomsTree.setCurrentKey(this.classifyItem._id)
          this.getIdiomsList()
        })
      } catch (error) {}
    },

    classifyTreeClick(item) {
      this.classifyItem = item
      this.idiomsParams.idiomCategory = item._id
      this.getIdiomsList()
    },

    nodeExpand(data) {
      this.defaultExpandedKeys = [...this.defaultExpandedKeys, data._id]
    },
    nodeCollapse(data) {
      this.defaultExpandedKeys = this.defaultExpandedKeys.filter(
        (item) => item !== data._id
      )
    },

    addClassify(item = null) {
      this.dialogTitle = '新增'
      this.classifyForm.name = ''
      this.classifyForm.parent = item ? item._id : null
      this.showClassify = true
      this.focusInput()
    },

    async editClassify(item) {
      this.dialogTitle = '编辑'
      this.classifyEditItem = item
      this.classifyForm.name = item.name
      this.classifyForm.parent = item.parent
      this.showClassify = true
      this.focusInput()
    },

    async addClassifyEvn() {
      if (this.dialogTitle === '新增') {
        await this.$http.addIdiomsClassify(this.classifyForm)
        this.elMsg('添加成功', 'success')
      } else {
        await this.$http.updateIdiomsClassify(
          this.classifyEditItem._id,
          this.classifyForm
        )
        this.elMsg('编辑成功', 'success')
      }
      this.clearDialog()
      this.getIdiomsClassify()
    },

    async delClassify(item) {
      await this.$confirm(null, '确认删除？', {
        confirmButtonText: '确认',
        cancelButtonText: '取消',
        showClose: false,
        center: true
      })
      await this.$http.delIdiomsClassify(item._id)
      if (item._id === this.classifyItem._id) {
        this.classifyItem = null
        this.nodeCollapse(item)
      }
      this.getIdiomsClassify()
      this.elMsg('删除成功', 'success')
    },

    // ================ 常用语 =========================
    async getIdiomsList() {
      this.searchVal ? this.idiomsParams.title = this.searchVal : delete this.idiomsParams.title
      let res = await this.$http.getIdiomsList(this.idiomsParams)
      this.idioms = res.data.results
    },

    addIdioms() {
      this.dialogTitle = '新增'
      this.idiomsForm.content = ''
      this.idiomsForm.idiomCategory = this.classifyItem._id
      this.showIdioms = true
      this.focusInput()
    },

    clearDialog() {
      this.showIdioms = false
      this.showClassify = false
      // this.idiomsForm.content = "";
      // this.classifyForm.name = "";
    },

    async addEvn() {
      if (this.dialogTitle === '新增') {
        await this.$http.createIdioms(this.idiomsForm)
        this.elMsg('添加成功', 'success')
      } else {
        await this.$http.editIdioms(this.idiomsItem._id, this.idiomsForm)
        this.elMsg('编辑成功', 'success')
      }
      this.clearDialog()
      this.getIdiomsList()
      this.idiomsVisible = true
    },

    async setIdioms(text) {
      this.idiomsVisible = false
      this.$emit('setIdioms', text)
    },

    async editIdioms(item) {
      this.dialogTitle = '编辑'
      this.idiomsItem = item
      this.idiomsForm.content = item.content
      this.idiomsForm.idiomCategory = this.classifyItem._id
      this.showIdioms = true
      this.focusInput()
    },

    async delIdioms(id) {
      await this.$confirm(null, '确认删除？', {
        confirmButtonText: '确认',
        cancelButtonText: '取消',
        showClose: false,
        center: true
      })
      await this.$http.delIdioms(id)
      this.getIdiomsList()
      this.idiomsVisible = true
      this.elMsg('删除成功', 'success')
    },

    filterDesc(desc) {
      let val = desc ? desc.replace(/\n/g, '<br>') : ''
      return val
    },

    // ===========================================

    closeIdiomsPopover() {
      if(this.searchVal){
        this.$refs.listSearch.clearValue()
        this.searchHandle()
      }
    },
    searchHandle(val = '') {
      this.searchVal = val
      this.getIdiomsClassify()
    },

    focusInput() {
      this.$nextTick(() => {
        this.$refs.classifyInput ? this.$refs.classifyInput.focus() : null
        this.$refs.idiomsInput ? this.$refs.idiomsInput.focus() : null
      })
    }
  },
  mounted() {
    this.getIdiomsClassify()
  }
}
</script>

<style lang="scss">
.feedback-idioms-popover {
  padding: 0;

  .idioms-popover-main {
    position: relative;
    width: 1100px;
    height: 500px;
    display: flex;
    flex-direction: column;
    > .el-icon-error {
      font-size: 24px;
      position: absolute;
      top: -6px;
      right: -4px;
      color: red;
      cursor: pointer;
    }
    .idioms-popover-header {
      display: flex;
      justify-content: flex-end;
      border-bottom: 1px solid $globalBGColor;
      padding: 6px 20px;
      .idioms-popover-header-right {
        display: flex;
        align-items: center;
        .idioms-popover-search {
          margin: 0 20px;
        }
      }
    }
     .idioms-popover-content {
      display: flex;
      flex: 1;
      overflow: hidden;
      .idioms-popover-classify {
        width: 250px;
        border-right: 1px solid #ccc;
        display: flex;
        flex-direction: column;
        overflow: hidden;
        .idioms-popover-classify-main {
          flex: 1;
          overflow: hidden;
          padding: 10px 5px;
        }
        .idioms-addClassify {
          margin-top: 5px;
          text-align: center;
          color: $globalBGColor;
          font-weight: bold;
          border-top: 1px solid $globalBGColor;
          padding: 6px 0;
          cursor: pointer;
        }
      }
      .idioms-main {
        flex: 1;
        display: flex;
        flex-direction: column;
        overflow: hidden;
        .idioms-popover-list {
          flex: 1;
          flex-direction: column;
          overflow: hidden;
          padding: 10px;
        }
      }
     }
    .feedback-addIdioms {
      margin-top: 5px;
      text-align: center;
      color: $globalBGColor;
      font-weight: bold;
      border-top: 1px solid $globalBGColor;
      padding: 6px 0;
      cursor: pointer;
    }
    .idioms-popover-item {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 5px 10px;
      &:hover {
        background: $mainBGColor;
      }
      i {
        cursor: pointer;
        margin-left: 10px;
      }
      > p {
        flex: 1;
        cursor: pointer;
      }
    }
  }
}
.idioms-tree {
  .el-tree-node {
    .el-tree-node__content {
      margin-top: 5px;
      .idioms-tree-node {
        width: 250px;
        overflow: hidden;
        flex: 1;
        display: flex;
        align-items: center;
        justify-content: space-between;
        font-size: 14px;
        padding-right: 4px;
        .idioms-tree-node-name {
          flex: 1;
        }
      }
    }
  }
}
</style>
